/* eslint-disable class-methods-use-this */
/* eslint-disable no-const-assign */
import vars from '../helpers';

let parallax;

const helpers = {
	propertyCache: {},
	camelCase(value) {
		return value.replace(/-+(.)?/g, (match, character) => {
			return character ? character.toUpperCase() : '';
		});
	},
	vendors: [null, ['-webkit-', 'webkit'], ['-moz-', 'Moz'], ['-o-', 'O'], ['-ms-', 'ms']],
	accelerate(element) {
		helpers.css(element, 'transform', 'translate3d(0,0,0) rotate(0.0001deg)');
		helpers.css(element, 'transform-style', 'preserve-3d');
		helpers.css(element, 'backface-visibility', 'hidden');
	},
	css(element, property, value) {
		let jsProperty = helpers.propertyCache[property];

		if (!jsProperty) {
			for (let i = 0, l = helpers.vendors.length; i < l; i++) {
				if (helpers.vendors[i] !== null) {
					jsProperty = helpers.camelCase(`${helpers.vendors[i][1]}-${property}`);
				} else {
					jsProperty = property;
				}

				if (element.style[jsProperty] !== undefined) {
					helpers.propertyCache[property] = jsProperty;

					break;
				}
			}
		}

		element.style[jsProperty] = value;
	},
};

class Parallax {
	constructor(container) {
		this.raf = null;
		this.caf = null;
		this.posX = 0;
		this.posY = 0;
		this.PARALLAX_VAL = 15;
		container = container.length ? container[0] : container;
		this.layers = container.querySelectorAll('[data-parallax]');

		this.init();
	}

	setPosition(element, x, y) {
		x = `${x.toFixed(1)}px`;
		y = `${y.toFixed(1)}px`;

		helpers.css(element, 'transform', `translate3d(${x},${y},0)`);
	}

	onMouseMove(event) {
		this.posX = event.clientX;
		this.posY = event.clientY;
	}

	init() {
		if (!vars.isMobile()) {
			for (let index = 0; index < this.layers.length; index++) {
				const layer = this.layers[index];

				helpers.accelerate(layer);
			}
		}

		document.addEventListener('mouseenter', this.enable.bind(this));
		document.addEventListener('mouseleave', this.disable.bind(this));
		document.addEventListener('mousemove', this.onMouseMove.bind(this));
	}

	destroy() {
		this.disable();
		this.layers = null;
		document.removeEventListener('mouseenter', this.enable.bind(this));
		document.removeEventListener('mouseleave', this.disable.bind(this));
		document.removeEventListener('mousemove', this.onMouseMove.bind(this));
	}

	enable() {
		if (!this.raf) {
			this.caf = false;
			this.raf = requestAnimationFrame(this.onAnimationFrame.bind(this));
		}
	}

	disable() {
		if (!this.caf) {
			cancelAnimationFrame(this.raf);
			this.raf = null;
			this.caf = true;
		}
	}

	onAnimationFrame() {
		if (!this.layers || !this.layers.length) {
			return;
		}
		// let calibratedInputX = this.inputX - this.calibrationX;
		// let calibratedInputY = this.inputY - this.calibrationY;

		// if (Math.abs(calibratedInputX) > this.calibrationThreshold ||
		// 	Math.abs(calibratedInputY) > this.calibrationThreshold) {
		// 	this.queueCalibration(0);
		// }

		// if (this.portrait) {
		// 	this.motionX = this.calibrateX ? calibratedInputY : this.inputY;
		// 	this.motionY = this.calibrateY ? calibratedInputX : this.inputX;
		// } else {
		// 	this.motionX = this.calibrateX ? calibratedInputX : this.inputX;
		// 	this.motionY = this.calibrateY ? calibratedInputY : this.inputY;
		// }

		// this.motionX *= this.elementWidth * (this.scalarX / 100);
		// this.motionY *= this.elementHeight * (this.scalarY / 100);

		// if (!isNaN(parseFloat(this.limitX))) {
		// 	this.motionX = helpers.clamp(this.motionX, -this.limitX, this.limitX);
		// }

		// if (!isNaN(parseFloat(this.limitY))) {
		// 	this.motionY = helpers.clamp(this.motionY, -this.limitY, this.limitY);
		// }

		// this.velocityX += (this.motionX - this.velocityX) * this.frictionX;
		// this.velocityY += (this.motionY - this.velocityY) * this.frictionY;

		for (let index = 0; index < this.layers.length; index++) {
			const layer = this.layers[index];
			const dataOffset = layer.dataset.depth;
			const multiplier = -dataOffset / this.PARALLAX_VAL;
			// depthX = this.depthsX[index],
			// depthY = this.depthsY[index],
			// xOffset = this.velocityX * (depthX * (this.invertX ? -1 : 1)),
			// yOffset = this.velocityY * (depthY * (this.invertY ? -1 : 1))
			const xOffset = this.posX * multiplier;
			const yOffset = this.posY * multiplier;

			// если попадает в область видимости хоть часть элемента
			if (layer.getBoundingClientRect().top < innerHeight && layer.getBoundingClientRect().bottom > 0) {
				this.setPosition(layer, xOffset, yOffset);
			}
		}

		if (!this.caf) {
			requestAnimationFrame(this.onAnimationFrame.bind(this));
		}
	}
}

function init(container) {
	if (!parallax) {
		parallax = new Parallax(container);
	}
}

function destroy() {
	if (parallax) {
		parallax.destroy();
		parallax = null;
	}
}

function enable() {
	if (parallax) {
		parallax.enable();
	}
}

function disable() {
	if (parallax) {
		parallax.disable();
	}
}

export default {
	init,
	destroy,
	enable,
	disable,
};
